import React from "react"
import Fade from "react-reveal/Fade"

import {
  container,
  titleContainer,
  textContainer,
} from "./aboutText.module.sass"

const AboutText = ({ title, text }) => {
  return (
    <Fade>
      <div className={container}>
        <h2 className={titleContainer}>{title}</h2>
        <div className={textContainer}>
          {text.map(paragraph => {
            return <h5 key={paragraph.id}>{paragraph.content}</h5>
          })}
        </div>
      </div>
    </Fade>
  )
}

export default AboutText
